import {
  POST_JOB_SUCCESS,
  POST_JOB_ERROR,
  FILL_FORM,
  FILTER_CATEG0RIES,
  POST_JOB_CLEAR,
  SEND_EMAIL,
  EMPTY_EMAIL_DATA,
  NEWS_LETTER
} from "./types";

export const postJobSuccess = () => {
  return {
    type: POST_JOB_SUCCESS
  };
};

export const postJobClear = () => {
  return {
    type: POST_JOB_CLEAR
  };
};

export const postJobError = error => {
  return {
    type: POST_JOB_ERROR,
    payload: error
  };
};

export const fillForm = data => {
  return {
    type: FILL_FORM,
    payload: data
  };
};

export const makeFilterWithCategories = data => {
  return {
    type: FILTER_CATEG0RIES,
    payload: data
  };
};

export const sendEmail = data => {
  console.log(data)
  if(data===undefined){
    return {
      type: EMPTY_EMAIL_DATA,
      payload: data
    }
  }
  return {
    type: SEND_EMAIL,
    payload: data
  };
};


export const newsLetter = data => {
  console.log(data)
  return{
    type:NEWS_LETTER,
    payload:data
    
  }
}